import type { Container } from 'pixi.js';
import type { FXParticleEmitterConfig } from './FXParticleEmitterConfig';
import { FXParticleLayer } from './FXParticleLayer';

const partLibrary: Record<string, FXParticleEmitterConfig> = {};

export function loadParticles(): void {
  Object.entries(import.meta.glob('../../../assets/particles{ignore}/*.json')).forEach(async ([path, loader]) => {
    const regex = /([^/]+)\.json$/;
    const match = path.match(regex);
    const key = match ? match[1] : null;
    if (!key) return;

    try {
      partLibrary[key] = JSON.parse(JSON.stringify(await loader())) as FXParticleEmitterConfig;
    } catch (e) {
      console.warn(e);
    }
  });
}

loadParticles();

export function triggerParticleFX(key: string, container: Container, x = 0, y = 0): Promise<void> {
  const config = partLibrary[key];

  if (!config || container.destroyed) return Promise.resolve();

  const fxLayer = new FXParticleLayer(true).props({
    parent: container,
    x,
    y,
  });
  fxLayer.addParticleEmitter(0, 0, config);

  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  const { promise, resolve } = Promise.withResolvers<void>();

  fxLayer.onRemovedAllActiveEmitters.connect(() => {
    fxLayer.destroy();
    resolve();
  });

  return promise;
}
